import { useContext, useEffect } from 'react';
import { RenderPixelContext } from './RenderPixelProvider';

const WidgetLoaded = () => {
  const { onLoad } = useContext(RenderPixelContext);

  useEffect(() => onLoad(), [onLoad]);

  return null;
};

export default WidgetLoaded;
